<template>
  <v-row justify="center" class="alert-area">
    <v-col cols="12" xs="12" sm="10" md="10" lg="8" class="alert-text-area">
      <AlertEditableText
        :alert-text.sync="setComment"
        class="alert-text"
        :is-editable="decideEditable"
        v-if="userAuthority == 'MANAGER'"
      />
      <AlertText :alert-text="setComment" class="alert-text" v-else />
    </v-col>
    <!-- 通常時ボタンの背景は白 -->
    <v-btn
      class="alert-button"
      depressed
      @click="startEditing"
      v-if="userAuthority == 'MANAGER' && !isUnderEditing"
    >
      <p class="alert-button-text">編集する</p>
    </v-btn>
    <!-- 編集中はボタンの背景は黒くなる -->
    <v-btn
      class="alert-button"
      depressed
      @click="doneEditing"
      color="#000"
      v-if="userAuthority == 'MANAGER' && isUnderEditing"
    >
      <p class="alert-button-text done-text">完了する</p>
    </v-btn>
  </v-row>
</template>

<script>
import AlertEditableText from "../Atoms/AlertEditableText";
import AlertText from "../Atoms/AlertText";

export default {
  name: "Alert",
  data: () => ({
    isEditable: false,
    isUnderEditing: false
  }),
  methods: {
    startEditing() {
      this.isEditable = !this.isEditable;
      this.isUnderEditing = !this.isUnderEditing;
    },
    doneEditing() {
      this.isEditable = !this.isEditable;
      this.isUnderEditing = !this.isUnderEditing;

      const data = { comment: this.comment };
      this.axios
        .put("/api/teams/" + this.teamId, data)
        .then(response => {
          console.log("コメントのPUTのresponse", response);
        })
        .catch(error => {
          console.log("error", error);
        });
    }
  },
  computed: {
    decideEditable() {
      if (this.isEditable) {
        return false;
      } else {
        return true;
      }
    },
    setComment: {
      get() {
        return this.comment;
      },
      set(value) {
        this.$emit("update:comment", value);
      }
    }
  },
  components: {
    AlertEditableText,
    AlertText
  },
  props: ["userAuthority", "comment", "teamId"]
};
</script>

<style scoped>
h1 {
  color: #fff;
}
.alert-area {
  position: relative;
}
.alert-button {
  position: absolute;
  top: 18px;
  right: 19%;
  border-radius: 30px;
}
.alert-text-area {
  padding-bottom: 0;
}
.alert-button-text {
  text-align: center;
  font-weight: bold;
  margin: 0;
}
.done-text {
  color: #fff;
}
@media screen and (max-width: 350px) {
  .alert-button {
    right: 4%;
    padding: 5px !important;
  }
}
@media screen and (min-width: 351px) and (max-width: 767px) {
  .alert-button {
    right: 4%;
    padding: 5px !important;
  }
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .alert-button {
    right: 11%;
  }
}
@media screen and (min-width: 1024px) {
}
</style>
